.Route {
  padding: 2rem;
  overflow-x: hidden;
  max-width: 1024px;
  margin: 0 auto;
}

.Header {
  margin: 0 0 1rem;
  font-size: 1.2em;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 1ch;

  max-width: 100%;
  overflow: hidden;
  background-color: var(--color-panel-background);
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
}

.Title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1 auto;
}

.ExampleContainer {
  margin: 2rem 0;
}

.Code {
  display: block;
  white-space: pre;
  padding: 1rem;
  border-radius: 1rem;
  overflow-x: auto;
}

@media (max-width: 500px) {
  .Header {
    font-size: 1.4em;
  }
}
